import FormType from "../../../Components/Form/FormType";
import { ROLES } from "./Roles"; // Import from the new file

const AddAnnouncementFormOptions = {
  Fields: [
    {
      element: FormType.Input,
      required: true,
      name: "title",
      label: "Title",
      value: null,
      placeholder: "Insert announcement here",
    },
    {
      element: FormType.TextArea,
      required: true,
      name: "content",
      label: "Content",
      value: null,
      placeholder: "What is the content of this announcement",
    },
    [
      {
        element: FormType.DateOnly,
        name: "startDate",
        label: "Start Date",
        value: null,
        required: true,
        flex: 48,
      },
      {
        element: FormType.DateOnly,
        name: "endDate",
        label: "End Date",
        value: null,
        required: true,
        flex: 48,
      },
    ],
    {
      element: FormType.MultiSelectDropDown,
      name: "userConfiguration",
      label: "User Configuration",
      options: ROLES, // Use the imported roles here
      value: [],
      toggleOption: { label: "Select All Roles" },
    },
  ],
  Buttons: [
    {
      type: "button",
      text: "Cancel",
      className: "Btn-Mid Inverse",
      onClick: (navigate) => navigate(-1),
    },
    {
      type: "submit",
      text: "Save",
      className: "Btn-Mid Active",
    },
  ],
};

export default AddAnnouncementFormOptions;